import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { MapPinIcon } from 'lucide-react';
import { Badge } from '../../Badge';
export function AboutHero() {
  const reduce = useReducedMotion();
  return <section id="about-top" className="relative w-full overflow-hidden bg-deep-navy" style={{
    backgroundColor: '#0F4C81'
  }} data-id="element-17">
      {/* solid-color glow blobs (no multi-color gradients) */}
      <div className="pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-18">
        <div className="absolute -left-24 top-8 h-72 w-72 rounded-full bg-sky-blue opacity-20 blur-3xl" data-id="element-19" />
        <div className="absolute bottom-0 right-1/4 h-64 w-64 rounded-full bg-sage-green opacity-10 blur-3xl" data-id="element-20" />
      </div>

      <div className="relative mx-auto max-w-4xl px-4 py-20 text-center sm:px-6 sm:py-28" data-id="element-21">
        <motion.div initial={reduce ? undefined : {
        opacity: 0,
        y: 16
      }} whileInView={reduce ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-22">
          <div className="flex justify-center" data-id="element-23">
            <Badge variant="sky" style={{
            color: '#74A7C9',
            backgroundColor: 'rgba(116, 167, 201, 0.15)',
            borderColor: 'rgba(116, 167, 201, 0.3)'
          }} className="border" data-id="element-24">
              会社概要
            </Badge>
          </div>
          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-white sm:text-4xl lg:text-5xl" data-id="element-25">
            横須賀の中小企業に、
            <br className="hidden sm:block" data-id="element-26" />
            本業へ集中できる時間を。
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-27">
            OptiDSA（Opti Digital Services
            Agency）は、地域の中小企業のための伴走型デジタルパートナーです。
            SaaSを売るのではなく、あなたの現場に本当に合うサービスを一緒に選び、導入から運用まで並走します。
          </p>
          <p className="mt-6 inline-flex items-center gap-2 text-sm text-white/70" data-id="element-28">
            <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-29" />
            神奈川県横須賀市
          </p>
        </motion.div>
      </div>
    </section>;
}